const VIDEOS_WITH_MAKE_MODEL_ENDPOINT =
  "/:makeMaskingName(.+)-cars/:modelMaskingName([a-zA-Z0-9_-]+)/videos/";

const VIDEOS_WITH_MAKE_MODEL_VIDEO_NAME_ENDPOINT =
  VIDEOS_WITH_MAKE_MODEL_ENDPOINT + ":videoName([a-zA-Z0-9-]+)/";

const VIDEOS_WITH_NO_TAGGING_ENDPOINT = "/videos/:videoName([a-zA-Z0-9-]+)/";

export const VIDEO_DETAILS_ENDPOINTS = [
  VIDEOS_WITH_MAKE_MODEL_ENDPOINT,
  VIDEOS_WITH_MAKE_MODEL_VIDEO_NAME_ENDPOINT,
  VIDEOS_WITH_NO_TAGGING_ENDPOINT,
];

/* ADs */
export const MSITE_TOP_AD_OPTIONS = {
  path: "/1017752/Carwale_Mobile_Videos_320x50",
  id: "Carwale_Mobile_Videos_320x50_top_ad",
  size: [
    [320, 50],
    [320, 100],
    [300, 100],
    [300, 150],
    [320, 150],
  ],
};

export const DESKTOP_TOP_AD_OPTIONS = {
  path: "/1017752/Carwale_DSK_VideosDetails_970x90",
  id: "div-gpt-ad-1600861030157-0",
  size: [
    [970, 90],
    [970, 66],
    [960, 60],
    [728, 90],
    [960, 66],
    [970, 60],
  ],
};

export const YOUTUBE_AUTOPLAY_COOKIE = "YoutubeAutoplay";
export const INTERIOR_IMAGES_ICON =
  "https://imgd.aeplcdn.com/0x0/cw/static/icons/svg/editorial-icons/interior-icon.svg";
export const EXTERIOR_IMAGES_ICON =
  "https://imgd.aeplcdn.com/0x0/cw/static/icons/svg/editorial-icons/exterior.svg";
export const IMAGES_ICON =
  "https://imgd.aeplcdn.com/0x0/cw/static/icons/svg/editorial-icons/images.svg";
export const VIEWS_360_ICON =
  "https://imgd.aeplcdn.com/0x0/cw/static/icons/svg/editorial-icons/views-360.svg";
